var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H6V2H16V11V12H17H26V30ZM18 2.33125L25.6688 10H18V2.33125ZM18.5 0H6H4V2V30V32H6H26H28V30V9.5L18.5 0ZM11 16H10V18H11H21H22V16H21H11ZM11 20H10V22H11H21H22V20H21H11ZM11 24H10V26H11H21H22V24H21H11Z",
    fill: "#3B6CCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocPrimary);
export default __webpack_public_path__ + "static/media/Doc_Primary.16e53f5dc9309bb2a31fbf1e2c921b5a.svg";
export { ForwardRef as ReactComponent };